import {
  useBalances,
  useMerchantApiMutation,
  useMerchantApiQueryWithParams,
} from "../../hooks";
import {
  IPageAndSearchRequest,
  IViewMerchantDedicatedTopUpAccount,
  PagedMeta,
} from "../../interfaces-and-types";
import { View } from "./View";

interface IDvasByCurrency {
  currency: string | null;
}

export interface IDedicatedTopUpAccountsViewProps {
  activeBalanceCurrency: string | null;
  isLoading: boolean;
  isError: boolean;
  merchantTopUpAccounts: IViewMerchantDedicatedTopUpAccount[];
}

export const DedicatedTopUpAccounts = () => {
  const { activeBalanceCurrency } = useBalances();

  const {
    isLoading,
    isError,
    // isSuccess: isSuccess,
    data: merchantTopUpAccounts,
    // meta: merchantTopUpAccountsMeta,
  } = useMerchantApiQueryWithParams<
    IPageAndSearchRequest & IDvasByCurrency,
    IViewMerchantDedicatedTopUpAccount[],
    PagedMeta
  >([
    "getMerchantDedicatedTopUpAccounts",
    {
      page: 1,
      page_size: 20,
      search: null,
      currency: activeBalanceCurrency,
    },
  ]);

  return (
    <View
      activeBalanceCurrency={activeBalanceCurrency}
      isLoading={isLoading}
      isError={isError}
      merchantTopUpAccounts={merchantTopUpAccounts || []}
    />
  );
};
